import { render, staticRenderFns } from "./LmNewOrEdit.vue?vue&type=template&id=396005e2&"
import script from "./LmNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports